/**
 * @generated SignedSource<<1852105422f6c727d0223011ab2bf757>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ABTestConfigV2Audience = "MOBILE" | "RESPONSIVE" | "STANDARD" | "%future added value";
export type AbTestV2ConfigTestTypeEnum = "APP_SELLER_PREBUCKET" | "BUYER_APP_INSTANCE" | "BUYER_APP_USER" | "BUYER_CLIENT" | "BUYER_COOKIE" | "BUYER_USER" | "EMAIL" | "PUSH_BUYER" | "PUSH_SELLER" | "SELLER" | "SELLER_APP" | "SELLER_PREBUCKET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type clientAbTestV2_useAbTestV2BuyerUser_user$data = {
  readonly abTestV2List: ReadonlyArray<{
    readonly config: {
      readonly audience: ABTestConfigV2Audience | null;
      readonly createdDate: string | null;
      readonly description: string | null;
      readonly isActive: boolean | null;
      readonly modifiedDate: string | null;
      readonly ramp: number | null;
      readonly route: string | null;
      readonly testName: string | null;
      readonly testType: AbTestV2ConfigTestTypeEnum | null;
      readonly variations: ReadonlyArray<{
        readonly value: string | null;
        readonly weight: number | null;
      } | null> | null;
    } | null;
    readonly variant: string | null;
  } | null> | null;
  readonly " $fragmentType": "clientAbTestV2_useAbTestV2BuyerUser_user";
};
export type clientAbTestV2_useAbTestV2BuyerUser_user$key = {
  readonly " $data"?: clientAbTestV2_useAbTestV2BuyerUser_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"clientAbTestV2_useAbTestV2BuyerUser_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "clientAbTestV2_useAbTestV2BuyerUser_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "testType",
          "value": "BUYER_USER"
        }
      ],
      "concreteType": "AbTestConfigV2UserVariant",
      "kind": "LinkedField",
      "name": "abTestV2List",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AbTestConfigV2",
          "kind": "LinkedField",
          "name": "config",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "modifiedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "testName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "testType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "audience",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ramp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "route",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ABTestConfigV2Variation",
              "kind": "LinkedField",
              "name": "variations",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weight",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variant",
          "storageKey": null
        }
      ],
      "storageKey": "abTestV2List(testType:\"BUYER_USER\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3b35714983010dcda28112a28a0e5e80";

export default node;
